import {useTranslation} from 'react-i18next'

export function FilterSelect<T extends string>({
  value,
  onChange,
  options,
  optionLabel,
  ariaLabel,
  testId,
}: {
  value: T | ''
  onChange: (value: T | '') => void
  options: readonly T[]
  optionLabel: (option: T) => string
  ariaLabel: string
  testId: string
}) {
  const {t} = useTranslation()
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as T | '')}
      aria-label={ariaLabel}
      data-testid={testId}
      className="h-9 rounded-md border border-input bg-transparent px-2 text-sm text-foreground">
      <option value="">{t('cartera.filtroTodos')}</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {optionLabel(option)}
        </option>
      ))}
    </select>
  )
}
